import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { Button } from './ui/Button';
export const HeroSection = () => {
  const bullets = ['Sin meditación', 'Sin pastillas', 'Sin fuerza de voluntad', 'Sin técnicas complicadas'];
  return <section className="relative min-h-0 md:min-h-[90vh] flex items-center pt-6 pb-4 md:pt-20 md:pb-16 overflow-hidden bg-night-900" data-id="element-91">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-cta/10 rounded-full blur-[120px] pointer-events-none" data-id="element-92" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full" data-id="element-93">
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="text-center" data-id="element-94">
          <motion.span initial={{
          opacity: 0,
          scale: 0.8
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.5
        }} className="inline-block bg-cta/20 border border-cta/40 text-cta px-3 py-1 rounded-full text-xs md:text-base font-semibold mb-2 md:mb-6" data-id="element-95">
            Para vos que no podés dormir bien
          </motion.span>

          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-3 md:mb-10 text-white" data-id="element-96">
            No podés dormir porque tu cabeza no para. Eso tiene solución
          </h1>
        </motion.div>

        {/* Product mockup between headline and subtitle */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="w-full max-w-[110px] sm:max-w-[200px] md:max-w-xs mx-auto mb-3 md:mb-10" data-id="element-97">
          <a href="#compra" className="block relative group" data-id="element-98">
            <div className="absolute inset-0 bg-cta/20 rounded-2xl blur-2xl transition-all duration-500 group-hover:bg-cta/30 group-hover:blur-3xl" data-id="element-99" />
            <img src="https://images.unsplash.com/photo-1544947950-fa07a98d237f?w=400&q=80" alt="Libro Apagá la Cabeza y Dormite" className="relative z-10 w-full h-auto rounded-xl md:rounded-2xl shadow-2xl border border-night-700 transition-transform duration-500 group-hover:-translate-y-2" data-id="element-100" />
          </a>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="text-center" data-id="element-101">
          <p className="text-sm sm:text-lg md:text-xl text-gray-300 mb-3 md:mb-8 leading-relaxed max-w-2xl mx-auto" data-id="element-102">
            El sistema paso a paso para apagar pensamientos, relajar el cuerpo y
            dormirte.
          </p>

          <div className="grid grid-cols-2 md:flex md:flex-wrap justify-center gap-x-4 gap-y-1.5 md:gap-y-2 mb-4 md:mb-10 max-w-2xl mx-auto" data-id="element-103">
            {bullets.map((bullet, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.5 + idx * 0.1
          }} className="flex items-center gap-1.5 md:gap-2 text-gray-200" data-id="element-104">
                <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-accent-blue shrink-0" data-id="element-105" />
                <span className="text-xs md:text-base font-medium" data-id="element-106">
                  {bullet}
                </span>
              </motion.div>)}
          </div>

          <div className="space-y-2 md:space-y-4 max-w-xl mx-auto" data-id="element-107">
            <Button href="#compra" fullWidth className="text-center !py-3 md:!py-4 !text-sm md:!text-xl" data-id="element-108">
              ESTA NOCHE DUERMO
            </Button>
            <div className="flex flex-wrap justify-center gap-2 text-[10px] md:text-sm text-gray-400 font-medium" data-id="element-109">
              <span data-id="element-110">🔒 Pago seguro</span>
              <span data-id="element-111">·</span>
              <span data-id="element-112">Acceso instantáneo</span>
              <span data-id="element-113">·</span>
              <span data-id="element-114">PDF descargable</span>
              <span data-id="element-115">·</span>
              <span className="text-white" data-id="element-116">$19.999</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};